import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreatePrestacionEmpleadosHogar = () => {
  const [loadingCreatePrestacionEmpleadosHogar, setLoadingCreatePrestacionEmpleadosHogar] = useState(false);
  const [successCreatePrestacionEmpleadosHogar, setSuccessCreatePrestacionEmpleadosHogar] = useState(false);
  const [errorCreatePrestacionEmpleadosHogar, setErrorCreatePrestacionEmpleadosHogar] = useState(null);
  const [dataCreatePrestacionEmpleadosHogar, setDataPrestacionEmpleadosHogar] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // CREATE
  const createPrestacionEmpleadosHogar = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreatePrestacionEmpleadosHogar(true);
    setSuccessCreatePrestacionEmpleadosHogar(false);
    setErrorCreatePrestacionEmpleadosHogar(null);

    apiRecord.newCertificadoPrestacionEmpleoHogar(userId, data)
      .then((res: any) => {
        setLoadingCreatePrestacionEmpleadosHogar(false);
        setSuccessCreatePrestacionEmpleadosHogar(true);
        setDataPrestacionEmpleadosHogar(res.data);
        _cb?.(res.data);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreatePrestacionEmpleadosHogar(false);
        setErrorCreatePrestacionEmpleadosHogar(err.response?.data);
      });
  };

  return {
    createPrestacionEmpleadosHogar,
    loadingCreatePrestacionEmpleadosHogar,
    successCreatePrestacionEmpleadosHogar,
    errorCreatePrestacionEmpleadosHogar,
    dataCreatePrestacionEmpleadosHogar
  };
};

export default useCreatePrestacionEmpleadosHogar;
